import request from '../request'

export default {
  getTiposRecurso: () => {
    return request.get('recurso_tipo')
  }
}
